import { search } from '../../services/Search'
import HeaderSearchField from './HeaderSearchField'

const HeaderSearch = () => (
  <HeaderSearchField
    searchFn={search}
    placeholder="Yleishaku"
    queryKeyPrefix="globalSearch"
  />
)

export default HeaderSearch
